import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <p>
          © {new Date().getFullYear()} Infi Tools. All rights reserved. 
          <br />
          Powered by <strong>Sun Tzu Technologies</strong>
        </p>
      </div>
    </footer>
  );
}

export default Footer; 